import React, { useEffect } from "react";
import { useContext } from "react";
import CustomerContext from "../../../context";
import { FCol, FRow } from "../../../../../../globalComponents/standard";
import { Box, Divider, Grid, Icon, Paper, Typography } from "@mui/material";
import Card from "./card";

const WalletBalanceComponent = React.memo(
  ({ balance, title, titleSize = "h1", color }) => {
    return (
      <FCol fullWidth justifyContent="center">
        <Box
          style={{
            width: "fit-content",
          }}
          alignSelf={"center"}
          textAlign={"center"}
        >
          <Typography
            style={{
              borderBottom: `5px solid ${color}`,
              borderRadius: 8,
              color,
            }}
            align="center"
            variant={titleSize}
          >
            {balance}
          </Typography>
          <Typography align="center" variant="caption" color="textSecondary">
            {title}
          </Typography>
        </Box>
      </FCol>
    );
  },
);

const _Wallet = () => {
  const { balances, getBalances } = useContext(CustomerContext);

  useEffect(() => {
    //getBalances();
  }, []);
  return (
    <Box sx={{ marginTop: "20dvh" }}>
      <Grid container justifyContent={"center"}>
        <Grid size={{ xs: 12 }}>
          <WalletBalanceComponent
            balance={balances.balance}
            title="Saldo de pontos"
            color="#575757"
          />
        </Grid>
        <Grid flexGrow={1} size={{ xs: 12 }} style={{ textAlign: "center" }}>
          <Icon style={{ fontSize: 72, color: "#ccc" }}>merge</Icon>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FRow justifyContent="space-around" alignItems="center">
            <WalletBalanceComponent
              balance={balances.totalEarned}
              title="Pontos Ganhos"
              color="#2e7d32"
              titleSize={"h4"}
            />
            <Icon>remove</Icon>
            <WalletBalanceComponent
              balance={balances.totalRedeemed}
              title="Pontos Resgatados"
              color="#8d0000"
              titleSize="h4"
            />
          </FRow>
        </Grid>
      </Grid>
    </Box>
  );
};

const Wallet = () => {
  const { balances, getBalances } = useContext(CustomerContext);

  return (
    <Box>
      <Card {...balances} />
    </Box>
  );
};

export default Wallet;
